<template>
  <div class="sms-biz-message-send-input">
    <AppScrollbar style="height: 100%">
      <div class="input-wrap">
        <el-input v-model="inputValue"
                  size="mini"
                  type="textarea"
                  placeholder="填写短信内容"></el-input>
      </div>
    </AppScrollbar>
  </div>
</template>

<script>
import AppScrollbar from '../../../../../../../../../elements/AppScrollbar'
export default {
  name: 'SmsBizMessageSendInput',
  components: {
    AppScrollbar
  },
  props: {
    value: String
  },
  computed: {
    inputValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>

<style lang="scss">
  .sms-biz-message-send-input {
    height: 100%;
    background-color: #fff;
    .input-wrap {
      padding: 15px;
    }
  }
</style>
